import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";

import * as componentTypes from "../../../../constants/componentTypes";
import * as matchingActions from "../../../../actions/matchingActions";
import * as navigationActions from "../../../../actions/navigationActions";
import * as modelHelper from "../../../../helpers/modelHelper";

import Button from "../../../global/generic/Button";
import CloseButton from "../../../global/generic/CloseButton";
import Modal from "../../../global/generic/Modal";
import SearchInputSelectBox from "../../../global/generic/SearchInputSelectBox";

import imgConfirm from "../../../../resources/img/svgicons/confirm.svg";

class SearchInStandardFormulasModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedFandeck: null,
            selectedFormula: null
        };
    }
    componentDidMount() {
        if (this.props.fandeckList.length === 0 || this.props.colorList.length === 0) {
            this.props.dispatchMatchingInitSearchAction(this.props.tabId);
        }
    }

    handleSaveMeasurementResults = () => {
        this.props.dispatchGetSpectralData(
            this.props.tabId,
            this.state.selectedFormula.id,
            this.state.selectedFandeck.id,
            this.props.params.callback
        );
        this.props.dispatchCloseModalAction();
    };

    handleCloseModalClick = () => {
        this.props.dispatchCloseModalAction();
        this.props.dispatchResetColor(this.props.tabId);
        this.props.dispatchResetFandeck(this.props.tabId);
    };

    getFandeckList = (fandeckName) => {
        this.callFunctionWithTimeout(() => {
            this.props.dispatchGetFandeck(this.props.tabId, this.props.color?.id, fandeckName, this.props.fts);
        });
    };

    getColorList = (colorName) => {
        this.callFunctionWithTimeout(() => {
            this.props.dispatchGetColor(this.props.tabId, this.props.fandeck?.id, colorName, this.props.fts);
        });
    };

    callFunctionWithTimeout = (func) => {
        let self = this;
        let tempTimeoutId = setTimeout(function () {
            if (tempTimeoutId === self.globalSerchTimeoutId) {
                func();
            }
        }, 700);

        this.globalSerchTimeoutId = tempTimeoutId;
    };

    setFandeck = (fandeck) => {
        this.props.dispatchSelectFandeck(this.props.tabId, fandeck);
        this.setState({selectedFandeck: fandeck});
    };

    setFormula = (formula) => {
        this.props.dispatchSelectFormula(this.props.tabId, formula, this.setFandeck);
        this.setState({selectedFormula: formula});
    };

    getContent = () => {
        return modelHelper.buildModalSection(
            <div className="col-12">
                <SearchInputSelectBox
                    optionsList={[]}
                    selectedValue={this.props.product}
                    property={"displayName"}
                    label={translate("general.product")}
                    placeholder={translate("searchPanel.productStartPlaceholder") + "..."}
                    loading={false}
                    disabled={true}
                    valueSelected={() => {}}
                    onChange={() => {}}
                />
                <SearchInputSelectBox
                    optionsList={this.props.fandeckList}
                    selectedValue={this.state.selectedFandeck}
                    property={"displayName"}
                    label={translate("general.fandeck")}
                    placeholder={translate("searchPanel.fandeckStartPlaceholder") + "..."}
                    loading={this.props.loading}
                    valueSelected={this.setFandeck}
                    onChange={this.getFandeckList}
                />
                <SearchInputSelectBox
                    optionsList={this.props.colorList}
                    selectedValue={this.state.selectedFormula}
                    property={"displayName"}
                    label={translate("general.color")}
                    placeholder={translate("searchPanel.colorNamePlaceholder") + "..."}
                    loading={this.props.loading}
                    valueSelected={this.setFormula}
                    onChange={this.getColorList}
                />
                <SearchInputSelectBox
                    optionsList={[]}
                    selectedValue={this.props.base}
                    property={"displayName"}
                    label={translate("general.base")}
                    placeholder={translate("searchPanel.baseStartPlaceholder") + "..."}
                    loading={false}
                    disabled={true}
                    valueSelected={() => {}}
                    onChange={() => {}}
                />
                <SearchInputSelectBox
                    optionsList={[]}
                    selectedValue={this.props.package}
                    property={"displayName"}
                    label={translate("general.package")}
                    placeholder={translate("searchPanel.packageStartPlaceholder") + "..."}
                    loading={false}
                    disabled={true}
                    valueSelected={() => {}}
                    onChange={() => {}}
                />
            </div>
        );
    };

    getFooter = () => {
        return modelHelper.buildModalSection(
            <React.Fragment>
                <CloseButton onClick={this.handleCloseModalClick} />
                <Button
                    svgBefore={imgConfirm}
                    label={<Translate value="general.select" />}
                    disabled={this.state.selectedFandeck === null || this.state.selectedFormula === null}
                    onClick={this.handleSaveMeasurementResults}
                />
            </React.Fragment>
        );
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(this.props.params.title)}
                content={this.getContent()}
                footer={this.getFooter()}
                styles={{width: "40%", height: "45vh"}}
            />
        );
    }
}

const mapStoreToProps = (store, ownProps) => {
    if (store.matchingTab[ownProps.tabId] === undefined) {
        return {
            loading: false,
            fandeck: null,
            fandeckList: [],
            color: null,
            colorList: [],
            product: null,
            base: null,
            package: null,
            fts: store.settings.fts
        };
    }

    return {
        loading: store.server.requests.some((request) => request.tabId === ownProps.tabId),
        fandeck: store.matchingTab[ownProps.tabId].fandeck,
        fandeckList: store.matchingTab[ownProps.tabId].fandeckList,
        color: store.matchingTab[ownProps.tabId].color,
        colorList: store.matchingTab[ownProps.tabId].colorList,
        product: store.matchingTab[ownProps.tabId].activeProduct,
        base:
            store.matchingTab[ownProps.tabId].activeBases.length > 0
                ? store.matchingTab[ownProps.tabId].activeBases[0]
                : null,
        package: store.matchingTab[ownProps.tabId].activePackage,
        fts: store.settings.fts
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchMatchingInitSearchAction: (tabId) => {
            dispatch(matchingActions.matchingTabInitSearch(tabId));
        },
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.SEARCH_IN_STANDARD_FORMULAS));
        },
        dispatchGetSpectralData: (tabId, colorantId, fandeckId, callback) => {
            dispatch(matchingActions.getSpectralDataForCif(tabId, colorantId, fandeckId, callback));
        },
        dispatchSelectFandeck: (tabId, fandeck) => {
            dispatch(matchingActions.selectFandeck(tabId, fandeck));
        },
        dispatchSelectFormula: (tabId, color) => {
            dispatch(matchingActions.selectColor(tabId, color));
        },
        dispatchGetColor: (tabId, fandeckId, colorName, fts) => {
            dispatch(matchingActions.getColorList(tabId, fandeckId, colorName, fts));
        },
        dispatchGetFandeck: (tabId, colorId, fandeckName, fts) => {
            dispatch(matchingActions.getFandeckList(tabId, colorId, fandeckName, fts));
        },
        dispatchResetColor: (tabId) => {
            dispatch(matchingActions.resetColor(tabId));
        },
        dispatchResetFandeck: (tabId) => {
            dispatch(matchingActions.resetFandeck(tabId));
        }
    };
};

export default SearchInStandardFormulasModal = connect(
    mapStoreToProps,
    mapDispatchToProps
)(SearchInStandardFormulasModal);
